package meineglasfaser.api.routes

import io.ktor.resources.Resource
import kotlinx.serialization.Serializable
import meineglasfaser.api.CustomerType
import kotlin.time.Instant

@Resource("/auth")
class AuthRoutes {
    @Resource("/admin-portal")
    class RealmAdminPortal(val parent: AuthRoutes = AuthRoutes()) {
        @Resource("/login")
        class Login(val parent: RealmAdminPortal = RealmAdminPortal()) {
            @Serializable
            data class RequestBody(
                val user: String,
                val password: String,
            )
        }

        @Resource("/logout")
        class Logout(val parent: RealmAdminPortal = RealmAdminPortal())
    }

    @Resource("/customer-portal")
    class RealmCustomerPortal(val parent: AuthRoutes = AuthRoutes()) {
        @Resource("/login")
        class Login(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val email: String,
                val password: String,
            )
        }

        @Resource("/logout")
        class Logout(val parent: RealmCustomerPortal = RealmCustomerPortal())

        @Resource("/register")
        class Register(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val type: CustomerType,
                val firstName: String?,
                val lastName: String?,
                val companyName: String?,
                val vatNumber: String?,
                val email: String,
                val password: String,
                val passwordRepeat: String,
                val tosAgreement: Boolean,
                val gdprAgreement: Boolean,
            )
        }

        @Resource("/verify")
        class Verify(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val id: String,
                val token: String,
            )
        }

        @Resource("/forgot-stage-1")
        class ForgotStage1(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val email: String,
            )
        }

        @Resource("/forgot-stage-2")
        class ForgotStage2(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val resetToken: String,
                val newPassword: String,
                val newPasswordRepeat: String,
            )
        }

        @Resource("/change-email")
        class ChangeEmail(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val newEmail: String,
            )
        }

        @Resource("/change-password")
        class ChangePassword(val parent: RealmCustomerPortal = RealmCustomerPortal()) {
            @Serializable
            data class RequestBody(
                val currentPassword: String,
                val newPassword: String,
                val newPasswordRepeat: String,
            )
        }
    }
}
